import { PublicSumbissionEnds } from 'shared/Constants';
import { APIManager } from 'shared/manager';
import AxiosManager from 'shared/manager/AxiosManager';

const getPublicSubmissionList = async (): Promise<any> =>
  APIManager.sendGet(
    PublicSumbissionEnds.SUBMISSION_LIST,
    true,
    {},
    {},
    AxiosManager
  );

const updateSubmissionList = async (id: string, status: any): Promise<any> =>
  APIManager.sendPut(
    PublicSumbissionEnds.APPROVE_SUBMISSION(id, status),
    {},
    true,
    {},
    {},
    AxiosManager
  );
const convertSubmission = async (id: string): Promise<any> =>
  APIManager.sendPut(
    PublicSumbissionEnds.CONVERT_SUBMISSION(id),
    {},
    true,
    {},
    {},
    AxiosManager
  );

export const PublicSubmissionService = {
  getPublicSubmissionList,
  updateSubmissionList,
  convertSubmission,
};
